import(/* webpackMode: "eager" */ "/Users/dejth/Workspace/dejth/property-management-system/node_modules/next/dist/client/image-component.js");
